/* Direct Embroidery: new look helpers (Oct 2026). No dependencies. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Let the announcement bar scroll away while the header sticks */
  function setAnnHeight() {
    var ann = document.querySelector('.announcement--root');
    root.style.setProperty('--de-ann-h', (ann ? ann.offsetHeight : 0) + 'px');
  }

  /* Slimmer header after scrolling */
  function onScroll() {
    if (window.scrollY > 60) root.classList.add('de-scrolled');
    else root.classList.remove('de-scrolled');
  }

  /* Reveal elements that start below the fold. Anything already on screen stays visible. */
  function setupReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var sel = [
      '[data-de-reveal]',
      '.template--page .template-page--root [data-item="rte-content"] > h2',
      '.template--page .template-page--root [class$="-feature"]',
      '.template--page .template-page--root [class$="-material"]',
      '.template--page .template-page--root [class$="-method"]',
      '.template--page .template-page--root [class$="-compare-card"]',
      '.template--page .template-page--root .de-faq details',
      '.template--page .template-page--root .de-cta-box'
    ].join(',');
    var els = Array.prototype.slice.call(document.querySelectorAll(sel));
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var delay = el.getAttribute('data-de-delay');
        if (delay) el.style.transitionDelay = delay + 'ms';
        el.classList.add('de-in');
        el.classList.remove('de-pre');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top > vh) {
        el.classList.add('de-pre');
        io.observe(el);
      }
    });
  }

  /* Count numbers up when they scroll into view */
  function setupCounts() {
    var els = document.querySelectorAll('[data-de-count]');
    if (!els.length) return;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-de-count')) || 0;
      if (reduce) { el.textContent = to; return; }
      var start = null, dur = 1400;
      function step(t) {
        if (!start) start = t;
        var p = Math.min(1, (t - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      el.textContent = '0';
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* Open or closed, based on shop hours in Sarasota (Mon to Fri, 9 to 5) */
  function setupOpenStatus() {
    var els = document.querySelectorAll('[data-de-open-status]');
    if (!els.length) return;
    function update() {
      var day = 1, hr = 10;
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
        var wd = '', h = '';
        parts.forEach(function (p) { if (p.type === 'weekday') wd = p.value; if (p.type === 'hour') h = p.value; });
        day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(wd);
        hr = parseInt(h, 10) % 24;
      } catch (e) { return; }
      var weekday = day >= 1 && day <= 5;
      var open = weekday && hr >= 9 && hr < 17;
      var text = 'Open now · until 5 PM';
      if (!open) {
        if (weekday && hr < 9) text = 'Closed · opens today at 9 AM';
        else if (day >= 1 && day <= 4) text = 'Closed · opens tomorrow at 9 AM';
        else text = 'Closed · opens Monday at 9 AM';
      }
      Array.prototype.forEach.call(els, function (el) {
        var t = el.querySelector('[data-de-open-text]');
        if (t) t.textContent = text;
        el.setAttribute('data-open', open ? 'true' : 'false');
        el.hidden = false;
      });
    }
    update();
    setInterval(update, 60000);
  }

  function init() {
    setAnnHeight();
    onScroll();
    setupReveal();
    setupCounts();
    setupOpenStatus();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setAnnHeight);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
